export const optionsDate = [
  { label: 'Hôm này', value: 'today' },
  { label: 'Hôm qua', value: 'yesterday' },
  { label: 'Ngày mai', value: 'tomorrow' },
  { label: 'Tháng này', value: 'ThisMonth' },
  { label: 'Tháng trước', value: 'PrevMonth' },
];